import { createSlice } from '@reduxjs/toolkit';
import { dispatcher } from '../../../helpers/projectHelper';

const initialState = {
  exportProjectLoading: false,
  generateFromDesignLoading: false,
  unityObjectImagesProcessing: false,
  createRoomLoading: false,
  createPropGroupLoading: false,
  pasteMaterialLoading: false,
  undoRedoLoading: false,
  draggablePropLoading: false,
}

const curatorLoaderSlicer = createSlice({
  name: 'curatorLoader',
  initialState,
  reducers: {
    resetState: () => {
      return initialState
    },
    setExportProjectLoading: (state, { payload }) => {
      state.exportProjectLoading = payload;
    },
    setGenerateFromDesignLoading: (state, { payload }) => {
      state.generateFromDesignLoading = payload;
    },
    setUnityObjectImagesProcessing: (state, { payload }) => {
      state.unityObjectImagesProcessing = payload;
    },
    setCreateRoomLoading: (state, { payload }) => {
      state.createRoomLoading = payload;
    },
    setCreatePropGroupLoading: (state, { payload }) => {
      state.createPropGroupLoading = payload;
    },
    setPasteMaterialLoading: (state, { payload }) => {
      state.pasteMaterialLoading = payload;
    },
    setUndoRedoLoading: (state, { payload }) => {
      state.undoRedoLoading = payload;
    },
    setDraggablePropLoading: (state, { payload }) => {
      state.draggablePropLoading = payload;
    },
  },
});

export const actions = curatorLoaderSlicer.actions;
export const curatorLoaderActions = curatorLoaderSlicer.actions;

export const curatorLoaderSelector = (state) => state.curatorLoader;
export const curatorLoaderReducer = curatorLoaderSlicer.reducer;
export default curatorLoaderReducer;

const ca = (action) => (loading) => dispatcher(action(loading));

export const setExportProjectLoading = ca(actions.setExportProjectLoading)
export const setGenerateFromDesignLoading = ca(actions.setGenerateFromDesignLoading)
export const setUnityObjectImagesProcessing = ca(actions.setUnityObjectImagesProcessing)
export const setCreateRoomLoading = ca(actions.setCreateRoomLoading)
export const setCreatePropGroupLoading = ca(actions.setCreatePropGroupLoading)
export const setPasteMaterialLoading = ca(actions.setPasteMaterialLoading)
export const setUndoRedoLoading = ca(actions.setUndoRedoLoading)
export const setDraggablePropLoading = ca(actions.setDraggablePropLoading)

export const selectExportProjectLoading = (state) => state.curatorLoader.exportProjectLoading;
export const selectGenerateFromDesignLoading = (state) =>
  state.curatorLoader.generateFromDesignLoading;
export const selectUnityObjectImagesProcessing = (state) =>
  state.curatorLoader.unityObjectImagesProcessing;
export const selectCreateRoomLoading = (state) => state.curatorLoader.createRoomLoading;
export const selectCreatePropGroupLoading = (state) => state.curatorLoader.createPropGroupLoading;
export const selectPasteMaterialLoading = (state) => state.curatorLoader.pasteMaterialLoading;
export const selectUndoRedoLoading = (state) => state.curatorLoader.undoRedoLoading;
export const selectDraggablePropLoading = (state) => state.curatorLoader.draggablePropLoading;
